import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function CGV() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-8 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          Retour à l'accueil
        </button>

        <h1 className="text-4xl font-light text-gray-900 mb-8">Conditions générales de vente</h1>

        <div className="prose prose-lg max-w-none space-y-8">
          <section>
            <p className="text-gray-600 leading-relaxed">
              Date de dernière mise à jour : Octobre 2025
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">1. Objet</h2>
            <p className="text-gray-600 leading-relaxed">
              Les présentes conditions générales de vente (CGV) régissent les relations contractuelles entre
              Campaly et ses clients dans le cadre de la fourniture de services de gestion de campagnes d'influence.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">2. Services proposés</h2>
            <p className="text-gray-600 leading-relaxed">
              Campaly propose une plateforme SaaS permettant de :
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>Gérer des campagnes d'influence</li>
              <li>Collaborer avec des créateurs de contenu</li>
              <li>Suivre les performances des collaborations</li>
              <li>Gérer les aspects administratifs et financiers</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">3. Tarifs et modalités de paiement</h2>
            <p className="text-gray-600 leading-relaxed">
              Les tarifs de nos services sont indiqués en euros (€) hors taxes sur notre page de tarification.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Le paiement s'effectue par carte bancaire via notre prestataire de paiement sécurisé Stripe.
              Les abonnements sont facturés mensuellement ou annuellement selon la formule choisie.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">4. Durée et renouvellement</h2>
            <p className="text-gray-600 leading-relaxed">
              Les abonnements sont souscrits pour une durée déterminée (mensuelle ou annuelle) et se renouvellent
              automatiquement sauf résiliation par le client avant la date de renouvellement.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">5. Résiliation</h2>
            <p className="text-gray-600 leading-relaxed">
              Le client peut résilier son abonnement à tout moment depuis son espace client.
              La résiliation prendra effet à la fin de la période d'abonnement en cours.
              Aucun remboursement ne sera effectué pour la période déjà payée.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">6. Obligations du client</h2>
            <p className="text-gray-600 leading-relaxed">
              Le client s'engage à :
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>Fournir des informations exactes lors de son inscription</li>
              <li>Respecter les conditions d'utilisation de la plateforme</li>
              <li>Ne pas utiliser la plateforme à des fins illégales</li>
              <li>Maintenir la confidentialité de ses identifiants de connexion</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">7. Obligations de Campaly</h2>
            <p className="text-gray-600 leading-relaxed">
              Campaly s'engage à :
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>Fournir un accès continu à la plateforme (sous réserve de maintenance)</li>
              <li>Assurer la sécurité et la confidentialité des données</li>
              <li>Fournir un support technique aux clients</li>
              <li>Maintenir et améliorer la plateforme</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">8. Disponibilité du service</h2>
            <p className="text-gray-600 leading-relaxed">
              Campaly s'efforce d'assurer une disponibilité optimale de la plateforme. Toutefois, des interruptions
              peuvent survenir pour des raisons de maintenance ou de force majeure. Campaly ne pourra être tenu
              responsable des interruptions temporaires du service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">9. Responsabilité</h2>
            <p className="text-gray-600 leading-relaxed">
              La responsabilité de Campaly est limitée aux dommages directs prouvés résultant de l'utilisation
              de la plateforme, dans la limite du montant des sommes versées par le client au cours des 12 derniers mois.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">10. Propriété intellectuelle</h2>
            <p className="text-gray-600 leading-relaxed">
              La plateforme Campaly et l'ensemble de ses éléments (code, design, contenus) sont la propriété
              exclusive de Campaly. Toute reproduction ou utilisation non autorisée est interdite.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">11. Données personnelles</h2>
            <p className="text-gray-600 leading-relaxed">
              Le traitement des données personnelles est régi par notre{' '}
              <a href="/politique-confidentialite" className="text-gray-900 underline">Politique de confidentialité</a>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">12. Modifications des CGV</h2>
            <p className="text-gray-600 leading-relaxed">
              Campaly se réserve le droit de modifier les présentes CGV à tout moment.
              Les clients seront informés de toute modification par email.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">13. Droit applicable et juridiction</h2>
            <p className="text-gray-600 leading-relaxed">
              Les présentes CGV sont soumises au droit français. En cas de litige, et après échec de toute
              tentative de résolution amiable, les tribunaux français seront seuls compétents.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">14. Contact</h2>
            <p className="text-gray-600 leading-relaxed">
              Pour toute question relative aux présentes CGV :<br />
              <a href="mailto:contact@campaly.com" className="text-gray-900 underline">contact@campaly.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
